/** SPA-navigate to a background task's details dialog (deep link
 *  `/bgtasks/:taskId`).
 *
 *  The route table is imported lazily AT CALL TIME on purpose: the callers are
 *  reachable from pages the route table itself imports — `useBatchAction` is in
 *  every grid — so a static import of `@/routes` here would be a module cycle.
 *
 *  Lives under `bgtasks/` rather than in a feature that happens to use it: it is
 *  shared by the export dialog and by every grid's batch snackbar.
 */
export function openBackgroundTask(taskId: string): void {
  void import('@/routes').then(({ router }) => router.navigate(`/bgtasks/${taskId}`));
}
